var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"商品信息","name":"first"}},[_c('ProduceInfo')],1),_c('el-tab-pane',{attrs:{"label":"商品新增","name":"second"}},[_c('ProduceAdd')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }